import eventHelper, { CONNECTION_EVENTS } from '@/utils/eventHelper';

const CHECK_INTERVAL_IN_MILLISECONDS: number = 5000;

let isOnline: boolean = true;
let reconnectTimeout: number | null = null;

if (process.env.NODE_ENV === 'production') {
  startReconnectProcess();
}

window.addEventListener('online', handleOnlineEvent);
window.addEventListener('offline', handleOfflineEvent);

function handleOnlineEvent() {
  startReconnectProcess();
}

function handleOfflineEvent() {
  isOnline = false;

  if (reconnectTimeout !== null) {
    clearTimeout(reconnectTimeout);

    reconnectTimeout = null;
  }

  eventHelper.dispatchEvent(CONNECTION_EVENTS.CONNECT_DOWN);
}

function startReconnectProcess() {
  reconnectTimeout = setTimeout(function timeout() {
    checkConnection();

    if (reconnectTimeout !== null) {
      reconnectTimeout = setTimeout(timeout, CHECK_INTERVAL_IN_MILLISECONDS);
    }
  }, CHECK_INTERVAL_IN_MILLISECONDS);

  eventHelper.dispatchEvent(CONNECTION_EVENTS.RECONNECT_STARTED);
}

function checkConnection() {
  const xhr = new XMLHttpRequest();

  eventHelper.dispatchEvent(CONNECTION_EVENTS.RECONNECT_TICK);

  xhr.addEventListener('readystatechange', () => {
    if (XMLHttpRequest.DONE === xhr.readyState) {
      if ([200, 201, 202, 203, 204, 205, 206].includes(xhr.status)) {
        eventHelper.dispatchEvent(CONNECTION_EVENTS.RECONNECT_SUCCESS);

        if (!isOnline) {
          isOnline = true;

          eventHelper.dispatchEvent(CONNECTION_EVENTS.CONNECT_UP);
        }
      } else {
        eventHelper.dispatchEvent(CONNECTION_EVENTS.RECONNECT_FAILURE);

        if (isOnline) {
          isOnline = false;

          eventHelper.dispatchEvent(CONNECTION_EVENTS.CONNECT_DOWN);
        }
      }
    }
  }, false);

  xhr.addEventListener('timeout', () => {
    eventHelper.dispatchEvent(CONNECTION_EVENTS.RECONNECT_STOPPED);
  }, false);

  xhr.timeout = CHECK_INTERVAL_IN_MILLISECONDS;

  xhr.open('GET', process.env.VUE_APP_PING_URL, true);
  xhr.send();
}
